import React from "react";
import { Link } from "react-router-dom";
import { MapPin, ArrowUpRight } from "lucide-react";
import { SectionHeading } from "./ui";
import { Reveal } from "./useReveal";
import { ROUTES } from "./data";

// City cards route into the live IDX search (/idx). Once the site is live on
// wallstrealty.com and iHomeFinder SEO pages are enabled, these can be
// upgraded to city-specific SEO URLs (e.g. /homes-for-sale/long-beach-ca).
const CITIES = [
  { name: "Los Angeles", tag: "Iconic city, endless opportunity" },
  { name: "Long Beach", tag: "Coastal living at its finest" },
  { name: "Cerritos", tag: "The heart of Southern California" },
  { name: "Anaheim", tag: "Family-friendly Orange County" },
  { name: "Costa Mesa", tag: "Modern coastal charm" },
  { name: "Lakewood", tag: "Classic neighborhoods, modern appeal" },
  { name: "Downey", tag: "Rich history, growing community" },
  { name: "San Gabriel", tag: "Culture, dining, and character" },
];

export const FeaturedCities = () => (
  <section className="py-16 lg:py-24 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <SectionHeading
          eyebrow="Featured Cities"
          title="Homes in Sought-After SoCal Neighborhoods"
          subtitle="Explore homes across communities buyers are searching right now. Updated through the Wallstreet Realty home search."
        />
      </Reveal>
      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {CITIES.map((c, i) => (
          <Reveal key={c.name} delay={i * 50}>
            <Link
              to={ROUTES.idx}
              data-testid={`city-card-${c.name.toLowerCase().replace(/\s+/g, "-")}`}
              className="lift group h-full block bg-[#F5F5F5] border border-[#E5E5E5] rounded-[20px] p-6 hover:border-[#C9A961]"
            >
              <div className="flex items-start justify-between">
                <div className="w-10 h-10 rounded-xl bg-white flex items-center justify-center shadow-sm">
                  <MapPin size={18} className="text-[#254369]" />
                </div>
                <ArrowUpRight size={20} className="text-[#2D2D37]/30 group-hover:text-[#C9A961] transition-colors" />
              </div>
              <h3 className="mt-5 font-heading font-bold text-lg text-[#2D2D37]">{c.name}</h3>
              <p className="mt-1 text-sm text-[#2D2D37]/60 leading-relaxed">{c.tag}</p>
              <span className="mt-4 inline-block text-sm font-medium text-[#254369] group-hover:text-[#C9A961] transition-colors">
                View Homes →
              </span>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
